import TableCellText from "ds/components/Table/Row/CellText";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { TreeNode } from "utils/tree";
import { SpaceWithParentAccessLevel } from "views/Account/Spaces/types";

const SpacesListInheritEntitiesCell = ({
  item: node,
  ...cellProps
}: TableSimpleCellProps<TreeNode<SpaceWithParentAccessLevel>>) => (
  <TableSimpleCell {...cellProps}>
    <TableCellText>{node.item.inheritEntities ? "Yes" : "No"}</TableCellText>
  </TableSimpleCell>
);

export default SpacesListInheritEntitiesCell;
